// Public routes
export const PUBLIC_ROUTES = {
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  SIGN_UP_NEW: '/sign-up-new',
  COMPLETE_PROFILE: '/complete-profile',
  NO_ORGANIZATION: '/no-organization',
  MARKETPLACE: '/marketplace',
};
export const ROOT_ROUTES = {
  HOME: '/',
  ORG_ROOT: '/org',
};
const getSlugBasePath = (orgSlug: string) => `/org/${orgSlug}`;
const getStoreBasePath = (orgSlug: string, storeId: string) =>
  `${getSlugBasePath(orgSlug)}/stores/${storeId}`;
export const ORG_ROUTES = (orgSlug: string) => ({
  STORE: (storeId: string) => `${getSlugBasePath(orgSlug)}/stores/${storeId}`,

  DOMAINS: () => `${getSlugBasePath(orgSlug)}/domains`,

  BASE: () => getSlugBasePath(orgSlug),
  ANALYTICS: () => getSlugBasePath(orgSlug),
  REPORTS: () => `${getSlugBasePath(orgSlug)}/reports`,
  REPORT_DETAILS: (reportId: string) => `${getSlugBasePath(orgSlug)}/reports/${reportId}`,

  SETUP: () => `${getSlugBasePath(orgSlug)}/setup`,

  ORDERS: () => `${getSlugBasePath(orgSlug)}/orders`,
  ORDER_DETAILS: (orderId: string) => `${getSlugBasePath(orgSlug)}/orders/${orderId}`,

  SUBSCRIPTIONS: () => `${getSlugBasePath(orgSlug)}/subscriptions`,
  SUBSCRIPTION_DETAILS: (subId: string) => `${getSlugBasePath(orgSlug)}/subscriptions/${subId}`,

  PAYMENTS: () => `${getSlugBasePath(orgSlug)}/payments`,
  PAYMENT_DETAILS: (paymentId: string) => `${getSlugBasePath(orgSlug)}/payments/${paymentId}`,

  DISPUTES: () => `${getSlugBasePath(orgSlug)}/disputes`,
  DISPUTE_DETAILS: (disputeId: string) => `${getSlugBasePath(orgSlug)}/disputes/${disputeId}`,

  STORES: () => `${getSlugBasePath(orgSlug)}/stores`,
  STORE_CREATE: () => `${getSlugBasePath(orgSlug)}/stores/create`,

  PROCESSORS: () => `${getSlugBasePath(orgSlug)}/processors`,
  PROCESSOR_CREATE: () => `${getSlugBasePath(orgSlug)}/processors/create`,
  BLOCK_RULES: () => `${getSlugBasePath(orgSlug)}/processors/block-rules`,
  BLOCK_RULE_CREATE: () => `${getSlugBasePath(orgSlug)}/processors/block-rules/create`,
  BLOCK_RULE_DETAILS: (id: string) => `${getSlugBasePath(orgSlug)}/processors/block-rules/${id}`,
  PROCESSOR_DETAILS: (processorId: string) => `${getSlugBasePath(orgSlug)}/processors/${processorId}`,
  PROCESSOR_EDIT_STRIPE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/stripe/edit`,
  PROCESSOR_EDIT_NMI: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/nmi/edit`,
  PROCESSOR_EDIT_ONYX: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/onyx/edit`,
  PROCESSOR_EDIT_ROUTESENSE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/routesense/edit`,
  PROCESSOR_EDIT_FINIX: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/finix/edit`,
  PROCESSOR_EDIT_MASTERCARD: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/mastercard/edit`,
  PROCESSOR_EDIT_AIRWALLEX: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/airwallex/edit`,
  PROCESSOR_EDIT_CHECKOUT: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/checkout/edit`,
  PROCESSOR_EDIT_TAGADAPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/tagadapay/edit`,
  PROCESSOR_EDIT_TAGADAPAY_ROUTER: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/tagadapay-router/edit`,
  PROCESSOR_EDIT_EFIPAYMENTS: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/efipayments/edit`,
  PROCESSOR_EDIT_MERCHANTSCALE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/merchantscale/edit`,
  PROCESSOR_EDIT_BAKOLAPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/bakolapay/edit`,
  PROCESSOR_EDIT_SANDBOX: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/sandbox/edit`,
  PROCESSOR_EDIT_TRUSTFLOW: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/trustflow/edit`,
  PROCESSOR_EDIT_KESSPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/kesspay/edit`,
  PROCESSOR_EDIT_OVRI: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/ovri/edit`,
  PROCESSOR_EDIT_CCAVENUE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/ccavenue/edit`,
  PROCESSOR_EDIT_NGENIUS: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/ngenius/edit`,
  PROCESSOR_EDIT_TAP: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/tap/edit`,
  PROCESSOR_EDIT_AUTHORIZENET: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/authorizenet/edit`,
  PROCESSOR_EDIT_CONVESIO: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/convesio/edit`,
  PROCESSOR_EDIT_ADYEN: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/adyen/edit`,
  PROCESSOR_EDIT_PAYLAND: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/payland/edit`,
  PROCESSOR_EDIT_PAYSAFE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/paysafe/edit`,
  PROCESSOR_EDIT_BLUESNAP: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/bluesnap/edit`,
  PROCESSOR_EDIT_WORLDPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/worldpay/edit`,
  PROCESSOR_EDIT_BRAINTREE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/braintree/edit`,
  PROCESSOR_EDIT_MOLLIE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/mollie/edit`,
  PROCESSOR_EDIT_FISERV: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/fiserv/edit`,
  PROCESSOR_EDIT_PAYSTACK: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/paystack/edit`,
  PROCESSOR_EDIT_PAYU: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/payu/edit`,
  PROCESSOR_EDIT_RAZORPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/razorpay/edit`,
  PROCESSOR_EDIT_PAYONE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/payone/edit`,
  PROCESSOR_EDIT_GLOBALPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/globalpay/edit`,
  PROCESSOR_EDIT_BUZIPAY: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/buzipay/edit`,
  PROCESSOR_EDIT_NETVALVE: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/netvalve/edit`,
  PROCESSOR_EDIT_XOALA: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/xoala/edit`,
  PROCESSOR_EDIT_UNLIMIT: (processorId: string) =>
    `${getSlugBasePath(orgSlug)}/processors/${processorId}/unlimit/edit`,

  CUSTOMERS: () => `${getSlugBasePath(orgSlug)}/customers`,
  CUSTOMER_DETAILS: (customerId: string) => `${getSlugBasePath(orgSlug)}/customers/${customerId}`,

  EXTERNAL_REQUESTS: () => `${getSlugBasePath(orgSlug)}/external-requests`,
  EXTERNAL_REQUEST_DETAILS: (requestId: string) =>
    `${getSlugBasePath(orgSlug)}/external-requests/${requestId}`,

  // Payment Flows (global, account-level)
  PAYMENT_FLOWS: () => `${getSlugBasePath(orgSlug)}/payment-flows`,
  PAYMENT_FLOW_CREATE: () => `${getSlugBasePath(orgSlug)}/payment-flows/create`,
  PAYMENT_FLOW_DETAILS: (flowId: string) => `${getSlugBasePath(orgSlug)}/payment-flows/${flowId}`,
  PAYMENT_FLOW_EDIT: (flowId: string) => `${getSlugBasePath(orgSlug)}/payment-flows/${flowId}/edit`,
  PAYMENT_FLOW_ABUSE_DETECTION: (flowId: string) =>
    `${getSlugBasePath(orgSlug)}/payment-flows/${flowId}/abuse-detection`,
  PAYMENT_FLOW_SMART_RETRY: (flowId: string) =>
    `${getSlugBasePath(orgSlug)}/payment-flows/${flowId}/smart-retry`,
  PAYMENT_FLOW_REBILL_3DS: (flowId: string) =>
    `${getSlugBasePath(orgSlug)}/payment-flows/${flowId}/rebill-3ds`,

  PROFILE: () => `${getSlugBasePath(orgSlug)}/profile`,
  REFERRAL: () => `${getSlugBasePath(orgSlug)}/referral`,
  BILLING: () => `${getSlugBasePath(orgSlug)}/billing`,
  ACCOUNT_MANAGER: () => `${getSlugBasePath(orgSlug)}/account-manager`,
  /**
   * @deprecated Moved to the org-independent {@link MANAGE_ROUTES}. Kept only
   * so the old URL can redirect — the page configures one platform-wide Apple
   * Pay integrator, so scoping it to an org always implied per-org config that
   * does not exist.
   */
  MANAGE_APPLE_PAY: () => `${getSlugBasePath(orgSlug)}/manage/apple-pay`,
  ACTIVATE_ACCOUNT: () => `${getSlugBasePath(orgSlug)}/activate-account`,

  SETTINGS: () => `${getSlugBasePath(orgSlug)}/settings`,
  SETTINGS_ORGANIZATION: () => `${getSlugBasePath(orgSlug)}/settings/organization`,
  SETTINGS_DEMO: () => `${getSlugBasePath(orgSlug)}/settings/demo`,
  SETTINGS_ACCESS_TOKENS: () => `${getSlugBasePath(orgSlug)}/settings/access-tokens`,
  SETTINGS_APPLE_PAY: () => `${getSlugBasePath(orgSlug)}/settings/apple-pay`,
  SETTINGS_AUDIT_TRAIL: () => `${getSlugBasePath(orgSlug)}/settings/audit-trail`,

  NOT_FOUND: () => `*`,
});

/**
 * Staff operations. Not org-scoped, because nothing here belongs to an
 * organization — the Apple Pay page configures a single platform-wide payment
 * platform integrator shared by every merchant. Gated on the account-manager
 * or superadmin role, like the admin backoffice below.
 */
export const MANAGE_ROUTES = {
  BASE: '/manage',
  /** Apple Pay under Tagada's payment platform integrator (PPIID). */
  APPLE_PAY: '/manage/apple-pay',
  /** Merchant-owned Apple Pay certificates (BYOK), formerly an AM tab. */
  APPLE_PAY_BYOK: '/manage/apple-pay-byok',
  /** The legacy platform-managed Apple Pay domain pool, formerly an AM tab. */
  APPLE_PAY_DOMAINS: '/manage/apple-pay-domains',
  /** On-chain crypto payments (crypto-api): platform wallets, revenue share, merchants. */
  CRYPTO_PAYMENTS: '/manage/crypto-payments',
};

// Admin backoffice (superadmin only). Not org-scoped: gated by global role.
export const ADMIN_ROUTES = {
  BASE: '/admin',
  REVENUE: '/admin/revenue',
  PROCESSING: '/admin/processing',
  CRYPTO: '/admin/crypto',
  INVOICED: '/admin/invoiced',
  PARTNERS: '/admin/partners',
  PARTNERS_NEW: '/admin/partners/new',
  /**
   * Function form because the edit page is per-partner. The CRM admin
   * doesn't navigate by partner `id` (slug is the human handle that
   * lives in URLs everywhere else — see `PARTNER_ADMIN_ROUTES`), so
   * we look the partner up by slug and resolve to `id` server-side
   * before calling `partners.update`.
   */
  PARTNERS_EDIT: (slug: string) => `/admin/partners/${slug}/edit`,
  /**
   * Unified IAM directory: every Tagada user (internal + every partner) in
   * one searchable table, with inline role + scope edit. Replaced the
   * legacy /admin/staff (internal-only) and supersedes
   * /admin/partner/:slug/team (single-partner team) for membership
   * management. Backed by the local `users` table mirror — fast, no
   * Clerk pagination at request time.
   */
  IAM: '/admin/iam',
  CRM_CONTRACT_TEMPLATE: '/admin/crm-contract-template',
} as const;

// TagadaRx desk. Not an admin surface: it is worked by rx_ops / rx_admin —
// Tagada's TGD Care team or a partner's own staff — so it lives in its own
// namespace instead of a tab in the backoffice. Not org-scoped.
export const RX_ROUTES = {
  /** Platform desk: every mailbox handled by TGD Care. */
  BASE: '/rx',
  /** Partner desk: the mailboxes / merchants of one white-label partner. */
  PARTNER: (partner: string) => `/rx/${partner}`,
} as const;

// Partner-scoped admin (partneradmin role or superadmin).
// Not org-scoped: gated by partner role + URL :partner param.
export const PARTNER_ADMIN_ROUTES = (partner: string) => ({
  BASE: `/partner-admin/${partner}`,
  REVENUE: `/partner-admin/${partner}/revenue`,
  PROCESSING: `/partner-admin/${partner}/processing`,
  CRYPTO: `/partner-admin/${partner}/crypto`,
  INVOICED: `/partner-admin/${partner}/invoiced`,
  REPORTS: `/partner-admin/${partner}/reports`,
  REPORT_DETAILS: (reportId: string) => `/partner-admin/${partner}/reports/${reportId}`,
  BILLING: `/partner-admin/${partner}/billing`,
  MERCHANTS: `/partner-admin/${partner}/merchants`,
  TEAM: `/partner-admin/${partner}/team`,
  CRM_KEYS: `/partner-admin/${partner}/crm-keys`,
  EMAIL: `/partner-admin/${partner}/email`,
  PAYOUTS: `/partner-admin/${partner}/payouts`,
});

// Store-level routes
export const STORE_ROUTES = (orgSlug: string, storeId: string) => ({
  // Store base
  STORE_BASE: () => getStoreBasePath(orgSlug, storeId),
  STORE_GENERAL: () => `${getStoreBasePath(orgSlug, storeId)}/general`,
  STORE_EDIT: () => `${getStoreBasePath(orgSlug, storeId)}/settings/edit`,

  // Products
  PRODUCTS: () => `${getStoreBasePath(orgSlug, storeId)}/general/products`,
  PRODUCT_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/products/create`,
  PRODUCT_DETAILS: (productId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/products/${productId}`,
  PRODUCT_EDIT: (productId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/products/${productId}/edit`,

  // Variants
  VARIANT_CREATE: (productId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/products/${productId}/variants/create`,
  VARIANT_DETAILS: (productId: string, variantId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/products/${productId}/variants/${variantId}`,
  VARIANT_LIST: (productId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/products/${productId}/variants`,

  // Promotions
  PROMOTIONS: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions`,
  PROMOTIONS_ANALYTICS: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions/analytics`,

  // Offers
  OFFERS: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions/offers`,
  OFFER_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions/offers/create`,
  OFFER_EDIT: (offerId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/promotions/offers/${offerId}`,

  // Discounts
  DISCOUNTS: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions/discounts`,
  DISCOUNT_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/promotions/discounts/create`,
  DISCOUNT_DETAILS: (promotionId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/promotions/discounts/${promotionId}`,

  // Upsells
  UPSELLS: () => `${getStoreBasePath(orgSlug, storeId)}/general/upsells`,
  UPSELL_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/upsells/create`,
  UPSELL_EDIT: (upsellId: string) => `${getStoreBasePath(orgSlug, storeId)}/general/upsells/${upsellId}`,
  POST_PURCHASE: () => `${getStoreBasePath(orgSlug, storeId)}/general/post-purchase`,
  POST_PURCHASE_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/post-purchase/create`,
  POST_PURCHASE_EDIT: (postPurchaseId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/post-purchase/${postPurchaseId}`,

  // Customer portal settings (mount + per-operation switches)
  CUSTOMER_PORTAL_SETTINGS: () => `${getStoreBasePath(orgSlug, storeId)}/settings/customer-portal`,

  // Recurring discounts settings (block coupons on recurring line items, with exemptions)
  RECURRING_DISCOUNTS_SETTINGS: () => `${getStoreBasePath(orgSlug, storeId)}/settings/recurring-discounts`,

  // Club settings (Membership / Credits / Club Offers tabs)
  CLUB_SETTINGS: () => `${getStoreBasePath(orgSlug, storeId)}/settings/club`,
  CLUB_SETTINGS_TAB: (tab: string) => `${getStoreBasePath(orgSlug, storeId)}/settings/club/${tab}`,

  // Taxes
  TAXES: () => `${getStoreBasePath(orgSlug, storeId)}/general/taxes`,

  // Tax Exemptions
  TAX_EXEMPTIONS: () => `${getStoreBasePath(orgSlug, storeId)}/general/taxes/exemptions`,
  TAX_EXEMPTIONS_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/taxes/exemptions/create`,

  // Shipping
  SHIPPINGS: () => `${getStoreBasePath(orgSlug, storeId)}/general/shippings`,
  SHIPPING_EDIT: (shippingRateId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/general/shippings/${shippingRateId}`,
  SHIPPING_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/general/shippings/create`,
  // Languages
  TRANSLATIONS: () => `${getStoreBasePath(orgSlug, storeId)}/settings/languages`,
  TRANSLATION_EDIT: (languageTranslationId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/settings/languages/${languageTranslationId}`,

  // Emails (top-level per-store section, grouped with Funnels & Payment Flows)
  EMAILS: () => `${getStoreBasePath(orgSlug, storeId)}/emails`,
  EMAIL_TEMPLATE_EDIT: (emailTemplateId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/emails/${emailTemplateId}`,
  EMAILS_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/emails/create`,
  EMAILS_SETTINGS: () => `${getStoreBasePath(orgSlug, storeId)}/emails/settings`,

  // Editor
  EDITOR: (instanceId: string) => `${getStoreBasePath(orgSlug, storeId)}/storefront/editor/${instanceId}`,

  // Funnels
  FUNNELS: () => `${getStoreBasePath(orgSlug, storeId)}/storefront/funnels`,
  FUNNEL_EDITOR: (funnelId: string) => `${getStoreBasePath(orgSlug, storeId)}/storefront/funnels/${funnelId}`,

  // Payment Flows
  PAYMENT_FLOWS: () => `${getStoreBasePath(orgSlug, storeId)}/payment-flows`,
  PAYMENT_FLOWS_LIST: () => `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows`,
  PAYMENT_FLOW_CREATE: () => `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/create`,
  PAYMENT_FLOW_DETAILS: (flowId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/${flowId}`,
  PAYMENT_FLOW_EDIT: (flowId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/${flowId}/edit`,
  PAYMENT_FLOW_ABUSE_DETECTION: (flowId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/${flowId}/abuse-detection`,
  PAYMENT_FLOW_SMART_RETRY: (flowId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/${flowId}/smart-retry`,
  PAYMENT_FLOW_REBILL_3DS: (flowId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/payment-flows/flows/${flowId}/rebill-3ds`,

  // Storefront
  STOREFRONT: () => `${getStoreBasePath(orgSlug, storeId)}/storefront`,
  STOREFRONT_DIRECT_LINKS: () => `${getStoreBasePath(orgSlug, storeId)}/storefront/direct-links`,
  STOREFRONT_MARKETPLACE: () => `${getStoreBasePath(orgSlug, storeId)}/storefront/marketplace`,
  STOREFRONT_MOUNT_POINTS: () => `${getStoreBasePath(orgSlug, storeId)}/storefront/mount-points`,
  STOREFRONT_EDITOR: (funnelId: string) => `${getStoreBasePath(orgSlug, storeId)}/storefront/${funnelId}`,

  // Plugins & Integrations
  PLUGINS: () => `${getStoreBasePath(orgSlug, storeId)}/storefront/plugins`,
  INTEGRATIONS: () => `${getStoreBasePath(orgSlug, storeId)}/integrations`,
  INTEGRATION_CONFIG: (provider: string) => `${getStoreBasePath(orgSlug, storeId)}/integrations/${provider}`,
  // Tagada Rx — paid add-on. These routes are only visible in the
  // CRM sidebar when `rx.integrationStatus.state === 'active'`.
  RX_OVERVIEW: () => `${getStoreBasePath(orgSlug, storeId)}/rx`,
  RX_CASES: () => `${getStoreBasePath(orgSlug, storeId)}/rx/cases`,
  RX_CASE_DETAIL: (caseId: string) => `${getStoreBasePath(orgSlug, storeId)}/rx/cases/${caseId}`,
  RX_CLINICAL_CONFIG: () => `${getStoreBasePath(orgSlug, storeId)}/rx/clinical-config`,
  RX_AFFILIATE_TERMS: () => `${getStoreBasePath(orgSlug, storeId)}/rx/affiliate-terms`,
  RX_STATEMENT: () => `${getStoreBasePath(orgSlug, storeId)}/rx/statement`,
  RX_PRODUCT_OFFERINGS: () => `${getStoreBasePath(orgSlug, storeId)}/rx/product-offerings`,
  RX_STOREFRONT: () => `${getStoreBasePath(orgSlug, storeId)}/rx/storefront`,
  INTEGRATION_CUSTOM_PAYMENT_HUB: () => `${getStoreBasePath(orgSlug, storeId)}/integrations/custom-payment`,
  INTEGRATION_CUSTOM_PAYMENT_NEW: () =>
    `${getStoreBasePath(orgSlug, storeId)}/integrations/custom-payment/new`,
  INTEGRATION_CUSTOM_PAYMENT_EDIT: (integrationId: string) =>
    `${getStoreBasePath(orgSlug, storeId)}/integrations/custom-payment/${integrationId}`,

  // Playground
  PLAYGROUND: () => `${getStoreBasePath(orgSlug, storeId)}/playground`,
});

// Pattern constants for matching (useful for active state detection)
export const ROUTE_PATTERNS = {
  GENERAL: '/general',
  PRODUCTS: '/general/products',
  PROMOTIONS: '/general/promotions',
  PAYMENT_FLOWS: '/payment-flows',
  STOREFRONT: '/storefront',
  SETTINGS: '/settings',
};

// Export everything as default for convenience
export default {
  PUBLIC_ROUTES,
  ROOT_ROUTES,
  ORG_ROUTES,
  STORE_ROUTES,
  ADMIN_ROUTES,
  PARTNER_ADMIN_ROUTES,
  ROUTE_PATTERNS,
};
